import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { investorApi } from "../../api/api";
import GradientButton from "./GradiantButton";
import { toast ,ToastContainer} from "react-toastify";
import SecondaryButton from "./SecondaryButton";
import "react-toastify/dist/ReactToastify.css";

const VerificationPage = () => {
  const navigate = useNavigate();
  const { token, user } = useParams();
  const [status, setStatus] = useState("pending");
  const [message, setMessage] = useState("Verifying...");
  const [loading, setLoading] = useState(false);

  // modal state
  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    const verify = async () => {
      if (token && user) {
        try {
          const res = await investorApi.verifyUser(token, user);
          if (res.status === 200) {
            setStatus("success");
            setMessage(res.data.message);
          }
        } catch (err) {
          setStatus("error");
          setMessage(err.response?.data?.message || "Verification failed");
        }
      } else {
        setStatus("error");
        setMessage("Invalid verification link");
      }
    };

    verify();
  }, [token, user]);

  const handleResend = async () => {
    if (!email) {
      toast.warn("Please enter your registered email");
      return;
    }

    setLoading(true);
   try {
  const response = await investorApi.resendVerification({ email });

  toast.success(
    "Verification link sent successfully. Please check your inbox."
  );

  // Close modal
  setOpenModal(false);
  setEmail("");

} catch (error) {
    
      if (error.response?.status === 404) {
        toast.warn("No account found with that email. Please check again.");
        // alert("No account found with that email. Please check again.");
      } else if (error.response?.status === 400) {
        // alert("Your account is already verified.");
        toast.info("Your account is already verified.");
      } else {
        toast.error(
          error.response?.data?.message ||
            "Failed to resend verification link."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Box
      sx={{
        height: "98vh",
        width: "98vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: status === "success" ? "green.100" : "red.100",
        textAlign: "center",
      }}
    >
      <Container maxWidth="sm">
        <Typography variant="h4" gutterBottom>
          {status === "success"
            ? " Verification Successful!"
            : " Verification Failed"}
        </Typography>

        <Typography variant="body1" gutterBottom>
          {message}
        </Typography>

        {status === "success" && (
          <GradientButton
            width="40%"
            height={50}
            text="Login"
            onClick={() => navigate("/login")}
            style={{ marginTop: "10px" }}
          />
        )}

        {status === "error" && (
          <Box mt={3}>
            <GradientButton
              width="50%"
              height={50}
              text="Resend Verification Link"
              onClick={() => setOpenModal(true)}
              style={{ marginTop: "10px" }}
            />
          </Box>
        )}
      </Container>

      {/* Modal for email input */}
     <Dialog  
  open={openModal}  
  onClose={() => setOpenModal(false)}  
  fullWidth  
  maxWidth="sm" // options: 'xs', 'sm', 'md', 'lg', 'xl'
  PaperProps={{
    sx: {
      width: "500px",   // custom width
      height: "300px",  // custom height
      borderRadius: 3,  // optional rounded corners
      p: 2              
    }
  }}
>
  <DialogTitle>Resend Verification Link</DialogTitle>
  <DialogContent>
    <TextField
      autoFocus
      margin="dense"
      label="Registered Email"
      type="email"
      fullWidth
      value={email}
      onChange={(e) => setEmail(e.target.value)}
    />
  </DialogContent>
  <DialogActions sx={{ p: 2 }}>
    <SecondaryButton
      width="30%"
      height={45}
      text="Cancel"
      onClick={() => setOpenModal(false)}
    />
    <GradientButton
      width="30%"
      height={45}
      text={loading ? "Sending..." : "Send Link"}
      onClick={handleResend}
    />
  </DialogActions>
</Dialog>

    </Box>
    <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default VerificationPage;
